import React, {Component} from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';

// Vendor Components
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import { Form, Field } from "react-final-form";
import { FORM_ERROR } from "final-form";

// Custom Components
import { TextFieldAdapter } from '../Form/TextFieldAdapter';
import { FormIcon } from '../Form/FormIcon';

import Snackbar from 'material-ui/Snackbar';
import Countdown from 'react-countdown-now';


import styled from 'styled-components';

class SessionTimeoutWarning extends Component {
    
    state = {
       
    };
    
    componentDidMount() {
        this.props.blurPage(true);    
    }

    handleCloseDialog = () => {
        this.props.onClose();
    }

    // BUTTONS
    getCancelButton = (handleClose) => {
        return (
            <FlatButton
                label={this.props.idleStatus !== 'INACTIVE' ? "Close" : "Cancel"}
                disableTouchRipple={true}
                disableFocusRipple={true}
                onClick={(event)=>{
                    handleClose();
                    this.props.blurPage(false);
                }}
                style={{marginRight: 12}}
            />
        );
    }

    render() {
        const { title, onClose, open, user } = this.props;
        
        const { currentDialog } = this.state;
        
        return (
            <div>
                {
                    <React.Fragment>
                        <div style={{
                                position: 'fixed',
                                width: '110%',
                                height: '110%',
                                top: '-5%',
                                left: '-5%',
                                background: 'rgba(0,0,0, 0.5)',
                                opacity: 0.8,
                                zIndex: 100,
                                WebkitTransition: '0.5s all',
                            }}
                        >
                            
                        </div>
                            
                        <Dialog
                            title={title}
                            modal={true}
                            open={open}
                            autoScrollBodyContent={true}
                        >
                            <React.Fragment>
                                <div style={{ marginTop: -10, marginBottom: 10, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                    {(this.props.idleStatus === 'INACTIVE') && <div>
                                        <p>
                                            To keep your health data secure, you will be logged out in 2 minutes.
                                        </p>
                                    </div>}
                                    {(this.props.idleStatus !== 'INACTIVE') && <div>
                                        <p>
                                            Looks like you're back. You can close the privacy filter by clicking "close".
                                        </p>
                                    </div>}
                                    {(this.props.idleStatus === 'INACTIVE') && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '2em', fontWeight: 'bold', color: 'darkred' }}>
                                        <Countdown date={Date.now() + 120000} />
                                    </div>}
                                    { this.getCancelButton(onClose) }
                                </div>
                                
                            </React.Fragment>
                        </Dialog>
                    </React.Fragment>
                }
            </div>
          );
    }
  }

  const SelectStyles = styled.div`
            .Select-menu {
                display: flex;
                flex-direction: column;
                width: 100%;
            }
            .Select-option {
                display: block;
            }

            .Select-input {
                width: 100px;
            }
            .Select-arrow-zone {
                padding-top: 4px;
                padding-right: 10px;
            }
            .Select-clear {
                padding-top: 7px;
                padding-right: 4px;
            }
            
            /* DropDown Styles */
            .Selet-menu-outer > div{
                width: 100px;
            }
        `;

  const mapStateToProps = ({auth, dialog, client, idle}) => {
    // console.log('%cSERVER ERROR @ MSTP','color: greenyellow');
    // console.log(auth.serverError);
    return {
        clientData: client.clientData,
        currentDialog: dialog.current,
        emailIsVerified: auth.verificationStatus,
        emailVerified: auth.authData.emailVerified,
        errorData: auth.serverError,
        passwordData: auth.passwordData,
        user: auth.authData,
        userEmail: (auth.authData) ? auth.authData.email : null,
        userId: (auth.authData) ? auth.authData.id : null,
        idleStatus: idle.idleStatus,
    };
  }

  export default connect(mapStateToProps, actions)(SessionTimeoutWarning);

  /*
  
  title
  altActionText
  mainActionText
  open 
  handleClose
  
  */


// WEBPACK FOOTER //
// ./src/js/components/Dialog/SessionTimeoutWarning.jsx